import { string } from "yup";
import { requiredFieldValidationMessage } from "./ValidationMessages";

export const yupGsdbValidation = (path: string) =>
  string()
    .uppercase()
    .required(requiredFieldValidationMessage("GSDB Code"))
    .matches(/^[A-Z0-9]+$/, "Only alphanumeric inputs are allowed")
    .max(10, "GSDB Code must be at most 10 characters")
    .default("");
